const TIPOS_DOCUMENTOS_AEAT = [
  {
    key: '200',
    id: '200',
    value: '200 - Otros documentos',
  },
  {
    key: '201',
    id: '201',
    value: '201 - Acta',
  },
  {
    key: '202',
    id: '202',
    value: '202 - Acuerdo',
  },
  {
    key: '203',
    id: '203',
    value: '203 - Alegaciones',
  },
  {
    key: '204',
    id: '204',
    value: '204 - Carta de pago',
  },
  {
    key: '205',
    id: '205',
    value: '205 - Certificado',
  },
  {
    key: '206',
    id: '206',
    value: '206 - Citación',
  },
  {
    key: '207',
    id: '207',
    value: '207 - Conformidad',
  },
  {
    key: '208',
    id: '208',
    value: '208 - Comunicación',
  },
  {
    key: '209',
    id: '209',
    value: '209 - Declaración',
  },
  {
    key: '210',
    id: '210',
    value: '210 - Denuncia',
  },
  {
    key: '211',
    id: '211',
    value: '211 - Diligencia',
  },
  {
    key: '212',
    id: '212',
    value: '212 - Factura',
  },
  {
    key: '213',
    id: '213',
    value: '213 - Garantía',
  },
  {
    key: '214',
    id: '214',
    value: '214 - Identificación',
  },
  {
    key: '215',
    id: '215',
    value: '215 - Informe',
  },
  {
    key: '216',
    id: '216',
    value: '216 - Inicio',
  },
  {
    key: '217',
    id: '217',
    value: '217 - Liquidación',
  },
  {
    key: '218',
    id: '218',
    value: '218 - Notificación',
  },
  {
    key: '219',
    id: '219',
    value: '219 - Orden de carga',
  },
  {
    key: '220',
    id: '220',
    value: '220 - Propuesta',
  },
  {
    key: '221',
    id: '221',
    value: '221 - Propuesta de inicio',
  },
  {
    key: '222',
    id: '222',
    value: '222 - Propuesta de resolución',
  },
  {
    key: '223',
    id: '223',
    value: '223 - Providencia de apremio',
  },
  {
    key: '224',
    id: '224',
    value: '224 - Reclamación',
  },
  {
    key: '225',
    id: '225',
    value: '225 - Recurso',
  },
  {
    key: '226',
    id: '226',
    value: '226 - Remisión al tribunal',
  },
  {
    key: '227',
    id: '227',
    value: '227 - Representación',
  },
  {
    key: '228',
    id: '228',
    value: '228 - Requerimiento',
  },
  {
    key: '229',
    id: '229',
    value: '229 - Resolución',
  },
  {
    key: '230',
    id: '230',
    value: '230 - Sentencia',
  },
  {
    key: '231',
    id: '231',
    value: '231 - Solicitud',
  },
  {
    key: '232',
    id: '232',
    value: '232 - Trámite de audiencia',
  },
  {
    key: '233',
    id: '233',
    value: '233 - Acuse de recibo',
  },
  {
    key: '234',
    id: '234',
    value: '234 - Autoliquidación',
  },
  {
    key: '235',
    id: '235',
    value: '235 - Mandamiento',
  },
  {
    key: '236',
    id: '236',
    value: '236 - Información externa',
  },
  {
    key: '237',
    id: '237',
    value: '237 - Diligencia de constancia publicación TEU',
  },
  {
    key: '238',
    id: '238',
    value: '238 - Diligencia de constancia notificación electrónica',
  },
  {
    key: '239',
    id: '239',
    value: '239 - Diligencia de constancia notificación Comp.Elect',
  },
  {
    key: '240',
    id: '240',
    value: '240 - Auto',
  },
  {
    key: '241',
    id: '241',
    value: '241 - Decreto judicial',
  },
  {
    key: '242',
    id: '242',
    value: '242 - Providencia judicial',
  },
  {
    key: '243',
    id: '243',
    value: '243 - INTER',
  },
  {
    key: '244',
    id: '244',
    value: '244 - Libro-registro de IVA',
  },
  {
    key: '245',
    id: '245',
    value: '245 - Contrato',
  },
  {
    key: '246',
    id: '246',
    value: '246 - Convenio',
  },
  {
    key: '247',
    id: '247',
    value: '247 - Publicación',
  },
  {
    key: '248',
    id: '248',
    value: '248 - Llamada',
  },
  {
    key: '249',
    id: '249',
    value: '249 - Requerimiento interno de información externa',
  },
  {
    key: '250',
    id: '250',
    value: '250 - Predeclaración',
  },
  {
    key: '251',
    id: '251',
    value: '251 - Baja',
  },
  {
    key: '252',
    id: '252',
    value: '252 - Escritura pública',
  },
  {
    key: '253',
    id: '253',
    value: '253 - Nota simple de registro de la propiedad',
  },
  {
    key: '254',
    id: '254',
    value: '254 - Acto único notarial',
  },
  {
    key: '255',
    id: '255',
    value: '255 - Registro mercantil',
  },
  {
    key: '256',
    id: '256',
    value: '256 - Convocatorias de cursos. Programas. etc..',
  },
  {
    key: '257',
    id: '257',
    value: '257 - Informes de evaluación de cursos',
  },
  {
    key: '258',
    id: '258',
    value: '258 - Documentos de asistencia a cursos',
  },
  {
    key: '259',
    id: '259',
    value: '259 - Diligencia de puesta a disposición',
  },
  {
    key: '260',
    id: '260',
    value: '260 - Sobre de Notificación',
  },
  {
    key: '261',
    id: '261',
    value: '261 - Diligencia de expiración DEHú',
  },
]

export {
  TIPOS_DOCUMENTOS_AEAT
}
